import { HttpClient } from 'api/http-client';
import { AccountFeature } from 'hooks/use-account-feature';

export interface AccountFeatureResponse {
  [key: string]: boolean;
}

export enum FeatureStatus {
  TrialPending = 'TRIAL_PENDING',
  InTrial = 'IN_TRIAL',
  TrialExpired = 'TRIAL_EXPIRED',
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
}

export interface FeatureResponse {
  [key: string]: {
    enabled: boolean;
    status?: FeatureStatus;
    expiryDate?: Date;
  };
}

class AccountFeatureHttpClient extends HttpClient {
  public enableFeature(
    feature: AccountFeature,
  ): Promise<AccountFeatureResponse> {
    return this.put(`features/${feature}`);
  }

  public disableFeature(
    feature: AccountFeature,
  ): Promise<AccountFeatureResponse> {
    return this.delete(`features/${feature}`);
  }

  public getFeaturesConfig(): Promise<FeatureResponse> {
    return this.get('features/configuration');
  }
}

export const AccountFeatureAPI = new AccountFeatureHttpClient();
